import { useEffect, useState } from "react";
import { Download, X, Smartphone } from "lucide-react";

const DISMISS_KEY = "omnibat_install_dismissed";

// Bannière discrète (mobile) invitant à installer l'app pour pointer plus vite.
export function InstallBanner() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const standalone = window.matchMedia?.("(display-mode: standalone)").matches;
    if (standalone || localStorage.getItem(DISMISS_KEY)) return;
    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); setShow(true); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const dismiss = () => { localStorage.setItem(DISMISS_KEY, "1"); setShow(false); };
  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    setDeferred(null); setShow(false);
  };

  if (!show) return null;

  return (
    <div className="lg:hidden mb-4 rounded-xl border border-brand-200 bg-brand-50 p-3 flex items-center gap-3" data-testid="install-banner">
      <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-brand-600 text-white">
        <Smartphone className="h-5 w-5" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-brand-900 leading-tight">Installez OMNIBAT ONE</p>
        <p className="text-xs text-brand-700/80 leading-tight">Pointez plus vite depuis votre écran d'accueil.</p>
      </div>
      <button onClick={install} data-testid="install-banner-btn"
        className="inline-flex items-center gap-1.5 rounded-lg bg-brand-600 px-3 py-2 text-xs font-semibold text-white hover:bg-brand-700 transition-colors">
        <Download className="h-4 w-4" /> Installer
      </button>
      <button onClick={dismiss} data-testid="install-banner-dismiss" className="p-1 text-brand-700/60 hover:text-brand-900">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
